<template>
  <div>
    <div class="products" id="pro" ref="pro">
      <!-- {{ counttest }}<br>
    <button style="font-size: 2rem" @click="counttest+=1">button</button>
    <a href="#" @click.prevent="counttest+=1" style="background:red;padding:10px">atag</a> -->
      <div v-for="cate in packageCate" :key="cate.id" class="categoryGroup">
        <h3 :id="'pktitle' + cate.id">{{ cate.categoryName }}</h3>
        <ul>
          <li
            v-for="(pack, index) in packages"
            :key="index"
            :style="{ display: pack.cateId == cate.id ? 'flex' : 'none', position: 'relative' }"
          >
            <!-- <template v-if="pack.cateId == cate.id"> -->
            <!-- <router-link :to="{ path: '/index/' + pack.info.packageId }"> -->
            <router-link :to="{ path: '/index/' + pack.info.packageId }">
              <!-- <div class="productItem"> -->
              <img :src="APIURL + 'images/items/' + pack.info.package_img" alt="" />
              <div class="intro">
                <h4>{{ pack.info.names }}</h4>
                <!-- <h5 v-if="pack.info.package_amount > 0">
                  還剩 {{ pack.info.package_amount }} {{ pack.info.unit }}
                </h5>
                <h5 v-if="pack.info.amount == 0">補貨中</h5> -->
                <p>
                  <span>NT {{ pack.info.packagePrice }} 元</span> / {{ pack.info.unit }}
                </p>
              </div>
              <!-- </div> -->
            </router-link>
            <div class="count" v-if="pack.info.package_amount > 0 && pack.info.exist == 1">
              <button @click="lessCart(pack.info.packageId, 'package')">
                <i class="fas fa-minus"></i>
              </button>
              <!-- <h6>{{ getCartItemCount(pack.info.packageId, "package") }}</h6> -->
              <input
                style="border-radius: 50px"
                type="text"
                readonly
                @click="openCountModal('package', pack)"
                :value="getCartItemCount(pack.info.packageId, 'package')"
              />
              <button
                @click="
                  addCart(
                    pack.info.packageId,
                    pack.info.names,
                    pack.info.packagePrice,
                    pack.info.package_img,
                    pack.info.unit,
                    'package',
                    pack.info.detail,
                    pack.info.package_amount
                  )
                "
              >
                <i class="fas fa-plus"></i>
              </button>
            </div>
            <div class="product_num" v-else style="width:10%">
              <span
                style='padding:2px 3px;
                 border-radius:3px; color:#ff5858;
                 background: rgb(255, 223, 223);'
                >已售完</span
              >
            </div>

            <!-- </template> -->
          </li>
        </ul>
      </div>

      <div v-for="cate in category" :key="cate.id" class="categoryGroup">
        <h3 :id="'title' + cate.id">{{ cate.categoryName }}</h3>
        <ul>
          <li v-for="prod in ProductFilter(cate.id)" :key="prod.id">
            <template v-if="prod.cateId == cate.id">
              <router-link :to="{ path: '/index/' + prod.productId }">
                <!-- <div class="productItem"> -->
                <img :src="APIURL + 'images/items/' + prod.productImg" alt="" />
                <div class="intro">
                  <h4>{{ prod.names }}</h4>
                  <h5 v-if="prod.amount > 0">還剩 {{ prod.amount }} {{ prod.unit }}</h5>
                  <h5 v-if="prod.amount == 0">補貨中</h5>
                  <p>
                    <span>NT {{ prod.sellPrice }} 元</span> / {{ prod.unit }}
                  </p>
                </div>
                <!-- </div> -->
              </router-link>
              <div class="count" v-if="prod.amount > 0">
                <button @click="lessCart(prod.productId, 'product')">
                  <i class="fas fa-minus"></i>
                </button>
                <!-- <h6>{{ getCartItemCount(prod.productId, "product") }}</h6> -->
                <input
                  style="border-radius: 50px"
                  type="text"
                  readonly
                  @click="openCountModal('product', prod)"
                  :value="getCartItemCount(prod.productId, 'product')"
                />
                <button
                  @click="
                    addCart(
                      prod.productId,
                      prod.names,
                      prod.sellPrice,
                      prod.productImg,
                      prod.unit,
                      'product',
                      null,
                      prod.amount
                    )
                  "
                >
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </template>
          </li>
        </ul>
      </div>

      <!-- <router-view /> -->
    </div>
    <div class="productModal" v-if="CountModalShow">
      <div class="bg" @click="CountModalShow = false"></div>
      <div class="modal">
        <div class="modalcontent">
          <!-- {{ ModalItem }} -->
          <img :src="APIURL + 'images/items/' + ModalItem.image" alt="" />
          <div class="content">
            <h3>{{ ModalItem.name }}</h3>
            <h4>NT {{ ModalItem.price }} 元 / {{ ModalItem.unit }}</h4>
            <h5 v-if="ModalItem.amount > 0 && ModalItem.type == 'product'">
              還剩 {{ ModalItem.amount }} {{ ModalItem.unit }}
            </h5>
            <h5 v-if="ModalItem.amount <= 0 && ModalItem.type == 'product'">補貨中</h5>
            <label v-if="ModalItem.amount > 0" for="">數量：</label>
            <input v-if="ModalItem.amount > 0" type="text" v-model="ModalItem.value" />
          </div>
        </div>
        <div class="modalfooter">
          <button @click="CountModalShow = false">取消</button>
          <button @click="ModalAddProduct">確認</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery';

export default {
  props: ['category', 'products', 'packages', 'packageCate'],
  computed: {
    now_hash() {
      return this.$store.state.hash;
    },
    CartData() {
      return this.$store.state.CartData;
    },
  },
  data() {
    return {
      counttest: 0,
      Active: '',
      APIURL: process.env.VUE_APP_APIURL,
      categoryHeight: [],
      // CartData: [],
      ModalItem: {
        type: '',
        image: '',
        name: '',
        price: '',
        id: '',
        value: '',
        unit: '',
        amount: '',
        detail: [],
      },
      CountModalShow: false,
    };
  },
  // created() {
  //   this.CartData = JSON.parse(localStorage.getItem('cartdata'));
  // },
  mounted() {
    this.$store.commit('setActive', 'title1');
    this.$nextTick(() => {
      this.$refs.pro.addEventListener('scroll', this.scrollevent);
    });
  },
  methods: {
    getCartItemCount(id, type) {
      const vm = this;
      vm.hasItem = false;
      vm.count = 0;
      if (type === 'package' && vm.CartData) {
        // console.log('packg');
        // console.log(`package${id}`);
        vm.CartData.forEach((item) => {
          // console.log(item.product_id, `package${id}`);
          if (item.product_id === `${id}`) {
            vm.hasItem = true;
            vm.count = item.count;
            // console.log(item, item.count);
          }
        });
      } else if (type === 'product' && vm.CartData) {
        vm.CartData.forEach((item) => {
          if (item.product_id === id) {
            vm.hasItem = true;
            vm.count = item.count;
          }
        });
      }

      return vm.count;
    },
    scrollevent() {
      const vm = this;

      this.packageCate.forEach((item) => {
        const height = {
          title: `pktitle${item.id}`,
          height: document.getElementById(`pktitle${item.id}`).offsetTop,
        };
        vm.categoryHeight.push(height);
      });
      this.category.forEach((item) => {
        const height = {
          title: `title${item.id}`,
          height: document.getElementById(`title${item.id}`).offsetTop,
        };
        vm.categoryHeight.push(height);
      });

      let tempActive = vm.categoryHeight.title;
      vm.categoryHeight.forEach((item) => {
        if (this.$refs.pro.scrollTop + 50 > item.height) {
          tempActive = `${item.title}`;
        }
      });

      this.Active = tempActive;
    },
    addCart(id, names, sellPrice, image, unit, type, detail, amount) {
      // account目前選擇的商品數量
      console.log(amount, this.getCartItemCount(id, type));
      if (amount > this.getCartItemCount(id, type)) {
        if (type === 'package') {
          this.$store.dispatch('ADD_TO_CART', {
            product_id: `${id}`,
            product_names: names,
            product_sellPrice: sellPrice,
            product_image: image,
            product_unit: unit,
            count: 1,
            isPackage: 1,
            products: detail,
          });
        } else {
          this.$store.dispatch('ADD_TO_CART', {
            product_id: id,
            product_names: names,
            product_sellPrice: sellPrice,
            product_image: image,
            product_unit: unit,
            count: 1,
            isPackage: 0,
          });
        }
      }
    },
    lessCart(id, type) {
      if (type === 'package') {
        this.$store.dispatch('LESS_TO_CART', {
          product_id: `${id}`,
        });
      } else {
        this.$store.dispatch('LESS_TO_CART', {
          product_id: id,
        });
      }
    },
    ProductFilter(id) {
      return this.products.filter((item) => item.cateId === id);
    },
    openCountModal(type, items) {
      const vm = this;
      if (type === 'package') {
        console.log(items);
        vm.ModalItem.type = type;
        vm.ModalItem.image = items.info.package_img;
        vm.ModalItem.name = items.info.names;
        vm.ModalItem.price = items.info.packagePrice;
        vm.ModalItem.id = items.info.packageId;
        vm.ModalItem.amount = items.info.package_amount;
        vm.ModalItem.unit = items.info.unit;
        vm.ModalItem.value = vm.getCartItemCount(items.info.packageId, 'package');
        vm.ModalItem.detail = items.info.detail;
        vm.CountModalShow = true;
      } else if (type === 'product') {
        vm.ModalItem.type = type;
        vm.ModalItem.image = items.productImg;
        vm.ModalItem.name = items.names;
        vm.ModalItem.price = items.sellPrice;
        vm.ModalItem.id = items.productId;
        vm.ModalItem.unit = items.unit;
        vm.ModalItem.amount = items.amount;

        vm.ModalItem.value = vm.getCartItemCount(items.productId, 'product');
        vm.CountModalShow = true;
      }
    },
    ModalAddProduct() {
      const vm = this;
      console.log('parseInt(vm.ModalItem.value, 10)', parseInt(vm.ModalItem.value, 10));
      console.log(Number(vm.ModalItem.value, 10));
      // console.log(parseInt(vm.ModalItem.value, 10));
      if (Number.isNaN(parseInt(vm.ModalItem.value, 10))) {
        alert('請輸入數字');
      } else if (parseInt(vm.ModalItem.value, 10) > vm.ModalItem.amount) {
        alert('數量大於庫存');
      } else if (vm.ModalItem.type === 'package') {
        if (
          parseInt(vm.ModalItem.value, 10) === 0
          && vm.getCartItemCount(vm.ModalItem.id, 'package') === 0
        ) {
          vm.CountModalShow = false;
        } else {
          this.$store.dispatch('ADD_TO_CART', {
            product_id: vm.ModalItem.id,
            product_names: vm.ModalItem.name,
            product_sellPrice: vm.ModalItem.price,
            product_image: vm.ModalItem.image,
            product_unit: vm.ModalItem.unit,
            count:
              parseInt(vm.ModalItem.value, 10) - vm.getCartItemCount(vm.ModalItem.id, 'package'),
            isPackage: 1,
            products: vm.ModalItem.detail,
          });
          vm.CountModalShow = false;
        }
      } else if (vm.ModalItem.type === 'product') {
        if (
          parseInt(vm.ModalItem.value, 10) === 0
          && vm.getCartItemCount(vm.ModalItem.id, 'product') === 0
        ) {
          vm.CountModalShow = false;
        } else {
          this.$store.dispatch('ADD_TO_CART', {
            product_id: vm.ModalItem.id,
            product_names: vm.ModalItem.name,
            product_sellPrice: vm.ModalItem.price,
            product_image: vm.ModalItem.image,
            product_unit: vm.ModalItem.unit,
            count:
              parseInt(vm.ModalItem.value, 10) - vm.getCartItemCount(vm.ModalItem.id, 'product'),
            isPackage: 0,
          });
          vm.CountModalShow = false;
        }
      }
    },
  },
  watch: {
    Active() {
      this.$store.commit('setActive', this.Active);
    },
    now_hash() {
      //   this.$nextTick(() => {
      //     // console.log(document.getElementById(this.now_hash).offsetTop);
      //     this.$refs.pro.scrollTo(
      //       0,
      //       document.getElementById(this.now_hash).offsetTop,
      //     );
      //   });
      //   console.log(this.now_hash);
      //   console.log(document.getElementById(this.now_hash));
      //   const title = document.getElementById(this.now_hash);
      //   title.offsetTop = 9;
      //   console.log(title.scrollTop);
      //   this.$refs.pro.scrollTop(200);
      //   console.log($(this.now_hash));
      //   console.log(this.$refs.pro);
      //   this.$refs.pro.offsetTop = 9;
    },
    // category() {
    // this.scrollevent(this.category);
    // this.category.forEach((item, index) => {
    //   this.categoryHeight[index] = {
    //     title: `title${item.id}`,
    //     height: document.getElementById(`title${item.id}`).offsetTop,
    //   };
    // });
    // },
  },
};
</script>
